import { EActionTypes, TReducerState, TReduxActions } from './types';

const initState: TReducerState = {
    title: '',
};

const reducerAppBar = (
    state: TReducerState = initState,
    action: TReduxActions,
): TReducerState => {
    switch (action.type) {
        case EActionTypes.SET_TITLE:
            return {
                ...state,
                title: action.payload.title,
            };
        case 'GLOBAL_RESET':
        case EActionTypes.APP_BAR_RESET:
            return { ...state, ...initState };
        default:
            return state;
    }
};

export default reducerAppBar;
